<template>
  <div class="lives-service-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <Button @click="showModel()" type="success" class="f-r">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createOrUpdate('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="选择园区">
          <Select v-model="dataInfo.smarkpark_id" filterable clearable @on-change="smarkparkChange">
            <Option v-for="item in smarkparkList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="选择场馆">
          <Select v-model="dataInfo.venue_id" filterable clearable>
            <Option v-for="item in venueList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称" prop="name">
          <Input v-model="dataInfo.name" placeholder="请输入名称..."></Input>
        </FormItem>
        <FormItem label="类型" label-position="top">
          <RadioGroup v-model="dataInfo.type" @on-change="teamtype">
            <Radio :label="0">个人</Radio>
            <Radio :label="1">团体</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="服务金额" v-if="showPrices">
          <Input v-model="dataInfo.prices" placeholder="请输入服务金额..."></Input>
        </FormItem>
        <FormItem label="说明" prop="descript">
          <Input
            type="textarea"
            v-model="dataInfo.descript"
            placeholder="输入说明..."
            :autosize="{minRows:4,maxRows:8}"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "lives-service-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      venueList: [],
      smarkparkList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "名称",
          key: "name",
          minWidth: 200
        },
        {
          title: "分类名称",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.type == "1" ? "团体" : "个人")
            ]);
          }
        },
        {
          title: "场馆名称",
          key: "type",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.venue == "" ? "" : params.row.venue.title
              )
            ]);
          }
        },
        {
          title: "状态",
          key: "status",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showPrices: true,
      dataInfo: {
        name: "",
        prices: "",
        descript: "",
        type: 0
      },
      showModalStatus: false,
      dataInfoValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        prices: [
          {
            required: true,
            message: "服务金额必须填写",
            trigger: "blur",
            type: "string"
          }
        ],
        descript: [{ required: true, message: "说明必须填写", trigger: "blur" }]
      }
    };
  },
  // 组件
  components: {},
  created: function() {
    this.$api.smartpark
      .list({
        page: 1,
        size: 100
      })
      .then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.smarkparkList = res.result.list;
        }
      });
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartservice
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    smarkparkChange(value) {
      if (value != undefined) {
        this.$api.smartvenue
          .list({ size: 9999, smarkpark_id: value })
          .then(res => {
            if (res.code == 200) {
              this.venueList = res.result.list;
            }
          });
      }
    },
    // 切换头条展示形式
    teamtype: function(val) {
      // 返回的是 lable值
      if (val == "0") {
        this.showPrices = true;
      } else if (val == "1") {
        this.showPrices = false;
      }
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        name: "",
        prices: "",
        descript: "",
        venue_id: 0,
        type: 0
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        name: "",
        prices: "",
        descript: "",
        venue_id: 0,
        type: 0
      };
      this.showModalStatus = !this.showModalStatus;
      this.$api.smartservice.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        // this.dataInfo.prices = res.result.prices.toString();
        // this.dataInfo.type = res.result.type.toString();
        if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
          this.thumblist.push({
            name: this.dataInfo.thumb,
            url: this.dataInfo.thumb,
            status: "finished"
          });
        }
        //切换头条展示形式
        if (this.dataInfo.type == 0) {
          this.showPrices = true;
        } else if (this.dataInfo.type == 1) {
          this.showPrices = false;
        }
      });
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.smartservice.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.smartservice.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.smartservice.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function(index, value) {
      var status = value == true ? 1 : 0;
      this.$api.smartservice.status({ id: index, status: status }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.smartservice.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>